module.exports = __webpack_public_path__ + "img/施廷榆.2f4418e9.jpg";